import React, { Fragment, useState, useEffect } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE as ISIZE } from "baseui/input";
import { Select, SIZE as SSIZE } from "baseui/select";
import { Textarea, SIZE as TSIZE } from "baseui/textarea";
import ImageUploaderComponent from "../../components/image-uploader/ImageUploaderComponent";
import { Radio, RadioGroup } from "baseui/radio";
import { connect, disptch } from "react-redux";
import { updateActiveTemplateProperties, updateTemplateThumbnailImage } from "../../redux/template/TemplateActions";
import {
  INDUSTRIES_LIST,
  TEMPLATE_SOLVERS_LIST,
  TOPICS_LIST,
} from "../../constants/TemplatesConstants";
import { ACCESS_TYPES, RESOURCE_TYPES } from "../../constants/AppEnums";
import { uploadTemplateThumbnailImage } from "../../redux/template/TemplateThunk";
import MultiSelect from "../../components/multi-select/MultiSelect";
import { getSignedUrl } from "../../helpers/S3Helpers";
import { GET_SIGNED_URL_PATH } from "../../constants/ApiConstants";
import { useTranslation } from "react-i18next";

function TemplatePropertiesAsideView(props) {
  const { t } = useTranslation("template");
  
  const [thumbnailImageUrl, setThumbnailImageUrl] = useState(
    props.thumbnailImageUrl
  );  
  const [templateData, setTemplateData] = useState({
    solver: [],
    topics: [],
    industries: [],
    description: "",
    title: "",
    access: ACCESS_TYPES.PUBLIC,
  });


  useEffect(() => {
    if (props.activeTemplate) {
      setTemplateData((prevData) => ({
        ...prevData,
        solver: TEMPLATE_SOLVERS_LIST.filter(
          (item) => item.id.toUpperCase() === props.activeTemplate.solver
        ),
        topics: TOPICS_LIST.filter((topic) =>
          (props.activeTemplate.topics || []).includes(topic.id)
        ),
        industries: INDUSTRIES_LIST.filter((industry) =>
          (props.activeTemplate.industries || []).includes(industry.id)
        ),
        description: props.activeTemplate.description || "",
        title: props.activeTemplate.title || "",
        access: props.activeTemplate.access || ACCESS_TYPES.PUBLIC,
      }));
    }
    if (props.activeTemplate?.thumbnailImageUrl) return;
    if (!props.activeTemplate?.id || !props.activeTemplate?.thumbnailImage) return;
    getSignedUrl(
      GET_SIGNED_URL_PATH,
      "template",
      `${props.activeTemplate.id}/${props.activeTemplate.thumbnailImage}`
    ).then((url) => {
      props.setTemplateThumnailImageUrl(url);
      setThumbnailImageUrl(url);
    });
  }, [props.activeTemplate]);

  const transformTemplateData = (template) => {
    return {
      ...template,
      solver: template.solver[0]?.id,
      topics: template.topics.map((topic) => topic.id),
      industries: template.industries.map((industry) => industry.id),
  };
  };              
  const handleUpdate = (updatedProperty, updatedValue) => {
    if (templateData[updatedProperty] !== updatedValue) {
      const updatedData = { ...templateData, [updatedProperty]: updatedValue };
      setTemplateData(updatedData);
      let currentData = transformTemplateData(updatedData);
      props.updateActiveTemplateProperties(currentData);
    }
  };
  const handleBlur = (propertyName) => {
    let currentData = transformTemplateData(templateData);    
    if (currentData[propertyName] !== props.activeTemplate[propertyName]) {
      props.updateActiveTemplateProperties({
        [propertyName]: currentData[propertyName],
      });
    }
  };
  return (
    <Fragment>
      <FormControl id="template-image" label={t('templateThumbnailImage')}>
        <ImageUploaderComponent
          height={"250px"}
          backgroundImage={thumbnailImageUrl}
          handleUploadFiles={props.uploadThumbnailImage}
        />
      </FormControl>
      <FormControl id="template-title" label={t('templateTitle')}>
        <Input
          size={ISIZE.mini}
          value={templateData.title}
          onChange={(e) => handleUpdate("title", e.target.value)}
          onBlur={() => handleBlur("title")}
        />
      </FormControl>
      <FormControl id="template-solver" label={t('solverLabel')}>
        <Select
          size={SSIZE.mini}
          options={TEMPLATE_SOLVERS_LIST}
          value={templateData.solver}
          clearable={false}
          searchable={false}
          placeholder={t('solverPlaceholder')}
          onChange={(params) => handleUpdate("solver", params.value)}
        />
      </FormControl>
      <FormControl id="template-description" label={t('templateDescription')}>
        <Textarea
          size={TSIZE.mini}
          value={templateData.description}
          onChange={(e) => handleUpdate("description", e.target.value)}
          placeholder={t('promptTemplateDescription')}
          onBlur={() => handleBlur("description")}
        />
      </FormControl>
      <FormControl id="template-topics" label={t('topicsLabel')}>
        <MultiSelect
          size={SSIZE.mini}
          items={TOPICS_LIST}
          value={templateData.topics}
          placeholder={t('topicsPlaceholder')}
          onChange={(selectedItems) => handleUpdate("topics", selectedItems)}
        />
      </FormControl>
      <FormControl id="template-industries" label={t('industiesLabel')}>
        <MultiSelect
          size={SSIZE.mini}
          items={INDUSTRIES_LIST}
          placeholder={t('industiesPlaceholder')}
          value={templateData.industries}
          onChange={(selectedItems) =>
            handleUpdate("industries", selectedItems)
          }
        />
      </FormControl>
      <FormControl label={t('accessLabel')}>
        <RadioGroup
          value={templateData.access}
          disabled={true}
          onChange={(e) => handleUpdate("access", e.target.value)}
        >
          <Radio
            value={ACCESS_TYPES.PUBLIC}
            description={t('templatePublicDescription')}
          >
            Public
          </Radio>
          <Radio
            value={ACCESS_TYPES.PRIVATE}
            description={t('templatePrivateDescription')}
          >
            Private
          </Radio>
        </RadioGroup>
      </FormControl>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  activeTemplate: state.template.activeTemplate,
  thumbnailImageUrl: state.template.activeTemplate?.thumbnailImageUrl,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveTemplateProperties: (template) => {
      dispatch(updateActiveTemplateProperties({ template }));
    },  
    uploadThumbnailImage: (imageFile) => {
      dispatch(uploadTemplateThumbnailImage(imageFile));
    },
  setTemplateThumnailImageUrl: (url) => {
    dispatch(updateTemplateThumbnailImage({ imageUrl: url }));
  }
};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatePropertiesAsideView);
